/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ID } from '@gh/common-shared-data';
import { AbstractRestService, optimisticLockingOf, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';
import { OfficeRolePermissionTreeDto, OfficeRoleTodoPermissionsDto } from './office-role-permission-tree.dto';
import { OfficeRolePermissionTreeMapper, OfficeRoleTodoPermissionMapper } from './office-role-permission-tree.mapper';

@Injectable()
export class OfficeRolePermissionTreeRestService extends AbstractRestService {
  constructor(settings: RestSettings) {
    super(settings);
  }

  getGeneralPermissions(id: ID): Observable<OfficeRolePermissionTreeDto> {
    return this.httpGet(
      `/office-roles/${id}/general-permissions`,
      optimisticLockingOf(OfficeRolePermissionTreeMapper));
  }

  updateGeneralPermissions(tree: OfficeRolePermissionTreeDto): Observable<OfficeRolePermissionTreeDto> {
    return this.httpPut(
      `/office-roles/${tree.roleId}/general-permissions`,
      tree,
      optimisticLockingOf(OfficeRolePermissionTreeMapper));
  }

  getSetupPermissions(id: ID): Observable<OfficeRolePermissionTreeDto> {
    return this.httpGet(
      `/office-roles/${id}/setup-permissions`,
      optimisticLockingOf(OfficeRolePermissionTreeMapper));
  }

  updateSetupPermissions(tree: OfficeRolePermissionTreeDto): Observable<OfficeRolePermissionTreeDto> {
    return this.httpPut(
      `/office-roles/${tree.roleId}/setup-permissions`,
      tree,
      optimisticLockingOf(OfficeRolePermissionTreeMapper));
  }

  getTodoPermissions(officeId: ID): Observable<OfficeRoleTodoPermissionsDto> {
    return this.httpGet(
      `/office-roles/${officeId}/todo-permissions`,
      OfficeRoleTodoPermissionMapper,
    );
  }

  saveTodoPermissions(officeId: ID,
                      permissions: OfficeRoleTodoPermissionsDto): Observable<OfficeRoleTodoPermissionsDto> {
    return this.httpPut(
      `/office-roles/${officeId}/todo-permissions`,
      permissions,
      OfficeRoleTodoPermissionMapper,
    );
  }
}
